module.exports = __webpack_public_path__ + "static/img/product_2_3.4acda5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_2_3.png
// module id = VlTI
// module chunks = 34